import { datadogRum, removeRumGlobalContext } from './datadogRum'
import Session from 'embed/services/Session'

import { RUMContextKeys } from './constants'

if (Session.sessionUuid) {
  datadogRum.addRumGlobalContext(RUMContextKeys.DD_CTX_SESSION_UUID, Session.sessionUuid)
}

if (Session.trackingUuid) {
  datadogRum.addRumGlobalContext(RUMContextKeys.DD_CTX_TRACKING_UUID, Session.trackingUuid)
}

export { datadogRum, removeRumGlobalContext, RUMContextKeys }
